
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SectorAirFlightDetailsComponent } from './sector-air-flight-details.component';
import { AirportDetailsModule } from './airport-details/airport-details.module';
import { LuggageModule } from 'libraries/luggage/luggage.module';
import { LocalizedModule } from "../../pipes/localized/localized.module";
import { CarbonFootprintModule } from "libraries/component/carbon-footprint/carbon-footprint.module";

@NgModule({
    imports: [
        CommonModule,
        AirportDetailsModule,
        LuggageModule,
        LocalizedModule,
        CarbonFootprintModule,
    ],
    exports: [
        SectorAirFlightDetailsComponent,
    ],
    declarations: [
        SectorAirFlightDetailsComponent,
    ],
})
export class SectorAirFlightDetailsModule { }
